// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Button_buttonWrapper__-NF2J","button":"Button_button__Zk130"};